import { FeatureFlagType } from 'constants/featureFlags'
import useFeatureFlagContext from './useFeatureFlagContext'

const useFeatureFlag = (featureFlagName: FeatureFlagType): string | boolean | void =>
  useFeatureFlagContext().settings(featureFlagName)

export default useFeatureFlag
